"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function nestGet(nestedObj, pathArr) {
    return pathArr.reduce((obj, key) => ((obj && obj[key] !== 'undefined') ? obj[key] : undefined), nestedObj);
}
exports.default = nestGet;
